import * as _ from "lodash";
import * as log from "loglevel";

import mobx, { action, autorun, computed, observable, reaction, runInAction } from "mobx";
import { Agent } from "../../services/agent";
import { BaseModel } from "./base-model";
import { ProjectMember } from "./project-member";
import { ProjectPermission } from "./project-permission";

export enum UserType {
	External = "External",
	Interal = "Interal",
	PowerUser = "PowerUser",
	Admin = "Admin",
}

const userTypeMap = {
	"External" : 1,
	"Interal" : 2,
	"PowerUser" : 3,
	"Admin" : 4,
}
export class User extends BaseModel{
	@observable username : string;
	// @observable internal : boolean;
	// @observable admin: boolean;
	// @observable firstName: any;
	// @observable otherPhone: any;
	// @observable mobilePhone: any;
	// @observable workPhone: any;
	// @observable phoneType: string;
	// @observable company: any;
	// @observable title: any;
	// @observable lastName: any;
	// @observable address1: any;
	// @observable address2: any;
	// @observable zip: any;
	// @observable country: any;
	// @observable city: any;
	@observable avatarLink: string;
	@observable accountType: number;
	@observable projectPermissions: ProjectPermission[] = [];
	@observable projectMemberships: ProjectMember[] = [];
	@observable requirements: AccountRequirements;
	// @observable access: number;
	@observable userType : UserType;
	@observable marketingOptInAccepted: boolean;
	@observable notificationOptInAccepted: boolean;
	@observable termsAccepted: boolean;
	@observable postLoginRedirectURL: string;
	@observable impersonate: boolean = false;
	@observable mfaEnabled: boolean;
	@observable mfaType: MFAType;

	constructor(data : any = {}) {
		super(data);
		this.fromJSON(data);

		if(data["impersonate"]) {
			this.impersonate = true;
		}
	}


	@action async save(){
		let userData = await Agent.User.save(this);

		runInAction(() => {
			this.fromJSON(userData);
		});
	}

	hasRequirement(req: AccountRequirements){
		return (this.requirements & req) == req;
	}

	hasPowerAccess() {
		return this.userType == UserType.Admin || this.userType == UserType.PowerUser;
	}

	hasAdminAccess() {
		return this.userType == UserType.Admin;
	}

	hasInternalAccess() {
		return userTypeMap[this.userType] >= userTypeMap[UserType.Interal];
	}

	hasJumpAccess(userType: UserType) {
		return userTypeMap[this.userType] > userTypeMap[userType];
	}

	ableToPurgeUser() {
		return userTypeMap[this.userType] >= userTypeMap[UserType.PowerUser];
	}

	@action clearLoginURL(){
		this.clearLoginURL = null;
	}

}

export enum AccountRequirements{
	None										= 0,
	TermsRequired						= 1 << 0,
	SetupRequired						= 1 << 1,
	MessageOptInRequired 		= 1 << 2,
	PasswordChangeRequired 	= 1 << 3,
	VerificationRequired 		= 1 << 4,
	ReAcceptTerms						= 1 << 5
}

export enum MFAType{
	email = 0,
}


// WEBPACK FOOTER //
// ./src/stores/models/user.ts